const doc = [({"da":({"js":({"nemoa":({"activities":({"show":({"live":({"live":"Live"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;